// <reference types="googlemaps" />
import { Component, OnInit, ViewChild, NgZone, ElementRef, HostListener, Inject, ɵSWITCH_ELEMENT_REF_FACTORY__POST_R3__, Output, EventEmitter, Input } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { FormDatosFinancierosComponent } from '../../form-datos-financieros/form-datos-financieros.component';
import { FormDatosComercialesComponent } from '../../form-datos-comerciales/form-datos-comerciales.component';
import { FormDatosPersonalesComponent } from '../../form-datos-personales/form-datos-personales.component';
import { MantenedorClientesModalDatosPersonalesComponent } from '../../modal-datos-personales/modal-datos-personales.component';
import { MantenedorClientesModalDatosFinancierosComponent } from '../../modal-datos-financieros/modal-datos-financieros.component';
import { MantenedorClientesModalDireccionesComponent } from '../../modal-direcciones/modal-direcciones.component';
import { MantenedorClientesModalDatosComercialesComponent } from '../../modal-datos-comerciales/modal-datos-comerciales.component';
import { MantenedorClientesModalResumenComponent } from '../../modal-resumen/modal-resumen.component';
import { RubroVendedorService } from 'src/app/services/rubro-vendedor.service';
import { timeStamp } from 'console';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientesService } from 'src/app/services/clientes.service';
import { Subscription } from 'apollo-client/util/Observable';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { debounceTime, filter } from 'rxjs/operators';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { comuna } from 'src/app/shared/object/comuna.model';
import { region } from 'src/app/shared/object/region.model';
import { territorio } from 'src/app/shared/object/territorio.model';
import { vendedor } from 'src/app/shared/object/vendedor.model';
import { ruta } from 'src/app/shared/object/ruta.model';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { bloqueo_historico } from 'src/app/shared/object/bloqueo_historico.model';
import { vendedor_rubro_cliente } from 'src/app/shared/object/vendedor_rubro_cliente.model';
import { ipt_vendedor_cliente } from 'src/app/shared/object/ipt_vendedor_cliente.model';
import { cliente_vendedor_rubro_IPT } from 'src/app/shared/object/cliente_vendedor_rubro_IPT.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { direccion } from 'src/app/shared/object/direccion.model';
import { maquinaJoin } from 'src/app/shared/object/maquina_join.model';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { tipo_cliente } from 'src/app/shared/object/tipo_cliente.model';
import { O_NOFOLLOW } from 'constants';
import { XLS_URL } from 'src/environments/environment';
import { MapsAPILoader, MouseEvent, AgmCoreModule } from '@agm/core';
import { constants } from 'fs';
import { condicion_pago } from 'src/app/shared/object/condicion_pago.model';
import { RutValidator } from 'ng9-rut';
import { RutService } from 'src/app/shared/services/rut.service';
import { ScrollSpyLinkDirective, TabsetComponent, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { CanalService } from 'src/app/services/canal.service';
import { TipoClienteService } from 'src/app/services/tipo-cliente.service';

interface cliente_vendedor_rubro_IPTFixed extends cliente_vendedor_rubro_IPT {
  rubros: any[];
  rubrosVisibles: boolean;
}

declare const google: any;

interface ErrorValidate {
  [s: string]: boolean;
}

@Component({
  selector: 'app-modal-edit-proveedor',
  templateUrl: './modal-edit-proveedor.component.html',
  styleUrls: ['../../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ModalEditProveedorComponent implements OnInit {
  private client: GraphQLClient = null;
  @Input() optionsCanal: Array<any> = [];

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('datosEditarProveedor', { static: true }) editProveedorModal: ModalDirective;

  @ViewChild(ModalEditProveedorComponent, { static: true }) modalEditarProveedor: ModalEditProveedorComponent;

  @ViewChild(MantenedorClientesModalResumenComponent, { static: true }) modalResumen: MantenedorClientesModalResumenComponent;
  @ViewChild(MantenedorClientesModalDatosComercialesComponent, { static: true }) modalDatosComerciales: MantenedorClientesModalDatosComercialesComponent;
  @ViewChild(MantenedorClientesModalDireccionesComponent, { static: true }) modalEditarDirecciones: MantenedorClientesModalDireccionesComponent;
  @ViewChild(MantenedorClientesModalDatosFinancierosComponent, { static: true }) modalDatosFinancieros: MantenedorClientesModalDatosFinancierosComponent;
  @ViewChild(MantenedorClientesModalDatosPersonalesComponent, { static: true }) editarModalDtoPersonales: MantenedorClientesModalDatosPersonalesComponent;

  @ViewChild(FormDatosPersonalesComponent, { static: true }) formDatosPersonales: FormDatosPersonalesComponent;
  @ViewChild(FormDatosComercialesComponent, { static: true }) formDatosComerciales: FormDatosComercialesComponent;
  @ViewChild(FormDatosFinancierosComponent, { static: true }) formDatosFinancieros: FormDatosFinancierosComponent;

  @ViewChild('staticTabs', { static: true }) staticTabs: TabsetComponent;

  public codigoModulo = 1;
  public rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
  loading: boolean = false;
  public listaComunasFiltro: comuna[];
  public listaRubros: rubro[];
  public listaTerritoriosDireccion: territorio[];
  public listaRutasDireccion: ruta[];
  public listaVendedor: vendedor[];
  public listaRegiones: region[];
  public listaTipoClientes: tipo_cliente[];
  public listaCliente: cliente_proveedor[] = null;
  public listaBloqueoHistorico: bloqueo_historico[];
  public itemCliente: cliente_proveedor;
  public clienteSeleccionado: cliente_proveedor | any;
  public clienteSeleccionadoData: any;
  public listaDirecciones: direccion[];
  public listaDireccionesCombo: direccion[];
  public itemDireccion: direccion;
  public listaVendedorRubroCliente: vendedor_rubro_cliente[];
  public listaIPTVendedorCliente: ipt_vendedor_cliente[];
  public listaClienteVendedorRubroIPT: cliente_vendedor_rubro_IPT[];
  listaClienteVendedorRubroIPTFixed: cliente_vendedor_rubro_IPTFixed[];

  public listaVendedorRubroClienteAgrega: vendedor_rubro_cliente[];
  public listaIPTVendedorClienteAgrega: ipt_vendedor_cliente[];

  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public rutCliente: number;
  public direccionCliente: number;
  public rutClienteFormateado: string;

  public filtroPrincipalRutCliente: string;
  public filtroPrincipalNombreCliente = '';
  public filtroPrincipalDireccionCliente = '';
  public filtroPrincipalComuna: string;
  public filtroPrincipalEstado: boolean = false;
  public filtroPrincipalEstadoBloqueo = false;
  public filtroxEstado: any;
  public filtroPrincipalVendedor: any;

  public filtroDireccionNombre: string;
  public filtroDireccionDireccion: string;

  public formAgregaDatosPersonales: FormGroup;

  public formDatosDirecciones: FormGroup;
  public formBuscaDatosGrillaPrincipal: FormGroup;

  public paginaActual: number;
  public totalRegistros: number;
  public totalPaginas: number;

  public paginaActualDirecciones: number;
  public totalRegistrosDirecciones: number;
  public totalPaginasDirecciones: number;

  public paginaActualBloqueo: number;
  public totalRegistrosBloqueo: number;
  public totalPaginasBloqueo: number;

  // check casa matriz o direccion
  readonly RB_CASAMATRIZ_: boolean = true;
  readonly RB_DIRECCION_ACT: boolean = false;

  public zoom: number = 16;
  public latitude: number;
  public longitude: number;
  private geoCoder;
  public address: string;
  public options = {
    types: ['address'],
  };

  @ViewChild('direccionForm', { static: false })
  public searchElementRef: ElementRef;

  // Utils
  private log: any;

  ShowLongLat = false;
  showButton = false;
  private scrollHeight = 100;
  private PageNum = 1;
  showButtonDown: boolean;
  long: number = 0;
  lat: number = 0;

  filterOptionsTipoCliente: Array<any> = [];
  //TODO: DATOS PROVENIENTES DE CONFIRM
  ProveedorRut: string = '';
  EnableNext: number = 1;

  //TODO: VARIABLES PARA SCROLL
  // listOfCliente: any;
  // currentPayLoad: any;
  // totalRegistrosPos: any;
  // totalPagPos: any;
  // PagPosActual: any;
  // notEmptyPost = true;
  // notscrolly = true;
  // subscription: Subscription;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    client: GraphQLClient,
    private spinner: NgxSpinnerService,
    private clientesService: ClientesService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private rutValidator: RutValidator,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private clienteProveedorService: ClienteProveedorService,
    private formValidatorsService: FormValidatorsService,
    private rubroVendedorService: RubroVendedorService,
    private canalService: CanalService,
    private tipoClienteService: TipoClienteService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES');
    this.client = client;

    this.formDatosDirecciones = this.construyeFormAgregaDatosDirecciones();

    this.zoom = 16;
  }

  // optionsProvincia: Array<any> = [];

  optionsRegion: Array<any> = [];
  optionsDatosDireccionAgregarComuna: Array<any> = [];

  optionsFiltroComuna: Array<any> = [];

  optionsTerritorioDireccion: Array<any> = [];

  optionsRutaDireccion: Array<any> = [];

  //TODO: OPTIONS DE FORM DATOS PERSONALES - EDIT PROVEEDOR
  optionsTipoCliente: Array<any> = [];

  //TODO: OPTIONS DE FORM DATOS DIRECCION - EDIT PROVEEDOR
  optionsDireccion: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsVendedor: Array<any> = [];

  //TODO: OPTIONS DE FORM DATOS FINANCIEROS - EDIT PROVEEDOR
  optionsCondicionPago: Array<any> = [];
  optionsListaPrecios: Array<any> = [];
  optionsTipoCobro: Array<any> = [];
  // FIN  OPTIONS DE FORM DATOS FINANCIEROS - EDIT PROVEEDOR

  public checkboxMatriz: any = { left: true };

  ngOnInit() {
    console.log('Options Canal:', this.optionsCanal);

    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerDatosVendedores();

    this.obtenerDatosComunas();

    this.obtenerDatosRegion();

    this.obtenerDatosTerritorio();

    this.obtenerDatosRuta();

    this.obtenerDatosTipoCliente();

    this.obtenerDatosModalFinancieros();
    // this.filtraGrillaVistaPrincipal();

    this.loadComboRubros();

    this.loadCanales();
    this.loadTiposClientes();
    // this.obtenerDatosComunasAgregarDireccion();

    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      const countryRestrict = { country: 'cl' };

      this.geoCoder = new google.maps.Geocoder();

      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address'],
        componentRestrictions: countryRestrict,
      });

      // const autocompleteEdita = new google.maps.places.Autocomplete(
      //   this.searchElementRefEdita.nativeElement,
      //   {
      //     types: ['address'],
      //     componentRestrictions: countryRestrict,
      //   }
      // );
      // autocomplete.setFields(['address_component']);

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.formDatosDirecciones.get('latitud').setValue(place.geometry.location.lat());
          this.formDatosDirecciones.get('longitud').setValue(place.geometry.location.lng());
          this.formDatosDirecciones.get('direccionFormateada').setValue(place.formatted_address);
          this.formDatosDirecciones.get('direccion').setValue(place.name);
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 16;
          this.address = place.formatted_address;
          const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === place.address_components[2].long_name.toUpperCase().trim());

          this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
        });
      });
    });
    this.formChangesSubscriptions();
  }

  loadCanales() {
    this.canalService.obtenerTodos((result: any) => {
      const { respuesta } = result;
      this.optionsCanal = respuesta.registros.map((canal) => ({ value: canal.idcanal, label: canal.descripcion }));
      // SE AGREGA EVENTO DE CAMBIOS AL PARAMETRO CANAL
    });
  }

  loadTiposClientes() {
    this.tipoClienteService.obtenerTodosYSinTipoCliente(({ respuesta }) => {
      this.optionsTipoCliente = respuesta.registros;
    });
  }

  loadAndShow(rut) {
    this.showModalAgregar();
    this.ProveedorRut = this.validadores._enmascaraRut(rut.toString());
    this.editProveedorModal.show();
    this.formDatosDirecciones.reset();
    this.formDatosPersonales.SearchUser(rut, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      const self = this;

      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.ShowLongLat = false;
      this.formDatosDirecciones.get('estadoDireccion').setValue(respuesta.direccionactiva);
      this.formDatosDirecciones.get('esCasaMatriz').setValue(true);

      this.formDatosDirecciones.get('nombre').setValue(respuesta.nombre);

      if (respuesta.nombrecomuna === null || respuesta.nombrecomuna === '') {
        this.formDatosDirecciones.get('direccionFormateada').setValue(respuesta.direccion_completa);
        this.formDatosDirecciones.get('direccion').setValue(respuesta.direccion_completa);
      } else {
        this.formDatosDirecciones.get('direccionFormateada').setValue(respuesta.direccion_completa + ', ' + respuesta.nombrecomuna);
        this.formDatosDirecciones.get('direccion').setValue(respuesta.direccion_completa + ', ' + respuesta.nombrecomuna);

        const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === respuesta.nombrecomuna);

        this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
        self.geoCoder.geocode(
          {
            address: respuesta.direccion_completa + ', ' + respuesta.nombrecomuna,
          },
          function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              self.formDatosDirecciones.get('latitud').setValue(results[0].geometry.location.lat());
              self.formDatosDirecciones.get('longitud').setValue(results[0].geometry.location.lng());
            }
          }
        );
      }

      this.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);
      this.formDatosDirecciones.get('contacto').setValue('');
      this.formDatosDirecciones.get('fijo').setValue(respuesta.fono_fijo);
      this.formDatosDirecciones.get('movil').setValue(respuesta.fono_movil);
      this.formDatosDirecciones.get('email').setValue(respuesta.mail_contacto);
      this.direccionCliente = respuesta.codigo_direccion;
      self.manejadorDireccionDespacho(false);
      this.formDatosDirecciones.get('facturarACasaMatriz').setValue(null);
      this.formDatosComerciales.SetGiroComercial(respuesta.giro);

      this.formDatosFinancieros.setlimiteCredito(respuesta.limite_credito);
      this.formDatosFinancieros.SetListaPrecio(respuesta.lista_precio_codigo);
      this.formDatosFinancieros.SetDescuentoMaximo(respuesta.descuento_maximo);
    });
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.formDatosDirecciones.get('latitud').setValue(position.coords.latitude);
        this.formDatosDirecciones.get('longitud').setValue(position.coords.latitude);
        this.zoom = 16;
        this.getAddress(position.coords.latitude, position.coords.longitude);
      });
    }
  }

  ShowCoordenadasLatLong({ checked }) {
    if (checked === true) {
      this.ShowLongLat = true;
      const a = this.formDatosDirecciones.get('direccion').value;
      this.formDatosDirecciones.get('direccNueva').setValue(a);
    } else {
      this.ShowLongLat = false;
      const a = this.formDatosDirecciones.get('direccNueva').value;
      this.formDatosDirecciones.get('direccion').setValue(a);
    }
  }

  formChangesSubscriptions() {
    this.formDatosDirecciones
      .get('latitud')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((latitud: number) => {
        // this.getAddress(latitud, this.formDatosDirecciones.get("longitud").value);
        this.latitude = latitud;
        this.EnableItem();
      });

    this.formDatosDirecciones
      .get('longitud')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((longitud: number) => {
        // this.getAddress(this.formDatosDirecciones.get("latitud").value, longitud);
        this.longitude = longitud;
        this.EnableItem();
      });
  }

  markerDragEnd($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.formDatosDirecciones.get('latitud').setValue($event.coords.lat);
    this.formDatosDirecciones.get('longitud').setValue($event.coords.lng);
    this.getAddress(this.latitude, this.longitude);
  }

  EnableItem() {
    const lat = this.formDatosDirecciones.get('latitud').value;
    const lng = this.formDatosDirecciones.get('longitud').value;
    this.getLocationPlace(lat, lng);
  }

  lastLocalitationLat: number = 0;
  lastLocalitationLong: number = 0;
  getLocationPlace(latitude: number, longitude: number) {
    this.lat = latitude;
    this.long = longitude;

    if (!latitude || !longitude) return;

    latitude = latitude;
    longitude = longitude;

    if (this.lastLocalitationLat !== latitude && this.lastLocalitationLong !== longitude) {
      this.lastLocalitationLat = latitude;
      this.lastLocalitationLong = longitude;

      this.geoCoder.geocode({ location: { lat: Number(this.lastLocalitationLat), lng: Number(this.lastLocalitationLong) } }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.ngZone.run(() => {
              // verify result

              this.zoom = 16;
              this.latitude = Number(this.lastLocalitationLat);
              this.longitude = Number(this.lastLocalitationLong);
              this.address = results[0].formatted_address;
            });
          } else {
            // window.alert(
            //   'No se encontraron resultados. Debe ingresarla manualmente.'
            // );
            this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
          }
        } else {
          // window.alert('Fallo de GeoCoder: ' + status);
          if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
            setTimeout(() => 3000);
          }
        }
      });
    }
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 16;
          this.address = results[0].formatted_address;
          this.formDatosDirecciones.get('direccionFormateada').setValue(results[0].formatted_address);
          this.formDatosDirecciones.get('direccion').setValue(results[0].formatted_address.split(',')[0]);

          const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === results[0].address_components[2].long_name.toUpperCase().trim());

          this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
        } else {
          // window.alert(
          //   'No se encontraron resultados. Debe ingresarla manualmente.'
          // );
          this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
        }
      } else {
        // window.alert('Fallo de GeoCoder: ' + status);
        if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
          setTimeout(() => 3000);
        }
      }
    });
  }

  eliminaVendedorRubro(rubroipt: any) {
    const { vendedor_codigo } = rubroipt;
    this.listaClienteVendedorRubroIPT = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.vendedor_codigo !== vendedor_codigo);
    this.setListaVendedoresFixed();
  }

  setCobradorByDefault() {
    if (!this.listaClienteVendedorRubroIPT) return;
    const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
    if (cobradoresMatches === 0 && this.listaClienteVendedorRubroIPT.length > 0) this.listaClienteVendedorRubroIPT[0].es_cobrador = true;
  }

  agregaVendedorRubro() {
    if (
      this.formDatosDirecciones.get('VendedorSel').value === null //||
      // this.formDatosDirecciones.get("RubroSel").value === null
    ) {
      // alert('Debe escoger vendedor y rubro');
      // this.toastService.warning("Debe escoger vendedor y rubro");
      this.toastService.warning('Debe escoger vendedor');
      return;
    }
    // for (const item of this.listaClienteVendedorRubroIPT) {
    //   const arr = [item.rubro_codigo, item.nombreRubro];
    //   const idx = arr.indexOf(
    //     this.formDatosDirecciones.get("RubroSel").value
    //   );
    //   if (idx !== -1) {
    //     // alert('El rubro ya se encuentra ingresado');
    //     this.toastService.info("El rubro ya se encuentra ingresado");
    //     return;
    //   }
    // }

    this.obtenerRubrosPorVendedor(
      this.formDatosDirecciones.get('VendedorSel').value,
      (respuesta) => {
        this.log('success', respuesta);

        console.log('muestrame', this.listaClienteVendedorRubroIPT);

        const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
        let nombreVendedor = '';
        this.listaVendedor.forEach((element) => {
          if (element.codigo === this.formDatosDirecciones.get('VendedorSel').value) {
            nombreVendedor = element.nombre;
          }
        });

        const vendedor_codigo_agregado = Number(this.formDatosDirecciones.get('VendedorSel').value);
        const isNew = this.listaClienteVendedorRubroIPT.findIndex((v: cliente_vendedor_rubro_IPTFixed) => v.vendedor_codigo === vendedor_codigo_agregado) < 0;

        const vendedorRubro = respuesta.filter((r) => r.asignado);
        if (vendedorRubro.length === 0) {
          this.toastService.error('Vendedor no tiene rubros asignados');
          return;
        }
        vendedorRubro.forEach((rubroVendedor) => {
          /** INICIO Agregar uno **/
          const sel: cliente_vendedor_rubro_IPT = {
            cliente_proveedor_rut: this.rutCliente,
            direccion_codigo: this.direccionCliente,
            es_cobrador: cobradoresMatches > 0 ? false : true,
            lunes: false,
            martes: false,
            miercoles: false,
            jueves: false,
            viernes: false,
            sabado: false,
            domingo: false,
            rut_empresa: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            vendedor_codigo: this.formDatosDirecciones.get('VendedorSel').value,
            rubro_codigo: rubroVendedor.rubro_codigo, //this.formDatosDirecciones.get("RubroSel").value,
            realiza_cobro_maquina: false,
            nombreVendedor,
            nombreRubro: rubroVendedor.rubro_nombre,
            unidad_negocio_codigo: [],
          };

          // this.listaRubros.forEach((element) => {
          //   if (
          //     element.codigo === this.formDatosDirecciones.get("RubroSel").value
          //   ) {
          //     sel.nombreRubro = element.descripcion;
          //   }
          // });

          this.listaClienteVendedorRubroIPT.push(sel);
        });
        /** FIN Agregar uno **/

        this.setListaVendedoresFixed();

        if (isNew) {
          this.hideAllRubrosPanel();
          this.listaClienteVendedorRubroIPTFixed[this.listaClienteVendedorRubroIPTFixed.length - 1].rubrosVisibles = true;
        } else {
          const indexVendedorRubrosDisplayed = this.listaClienteVendedorRubroIPTFixed.findIndex((v: cliente_vendedor_rubro_IPTFixed) => v.vendedor_codigo === vendedor_codigo_agregado);
          this.hideAllRubrosPanel();
          this.listaClienteVendedorRubroIPTFixed[indexVendedorRubrosDisplayed].rubrosVisibles = true;
        }
      },
      () => {
        this.log('error');
      }
    );
  }

  obtenerRubrosPorVendedor(vendedor_codigo: number, success: Function, error: Function) {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo,
      },
    };

    this.rubroVendedorService.obtenerRubrosVendedor(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        error();
        return;
      }

      success(respuesta);
    });
  }

  handleChangeCobrador(rubroipt: cliente_vendedor_rubro_IPTFixed) {
    const { vendedor_codigo } = rubroipt;

    // limpiar todos
    this.listaClienteVendedorRubroIPT.forEach((vendedor: cliente_vendedor_rubro_IPT) => {
      vendedor.es_cobrador = false;
    });

    const vendedorSeleccionadoIndex = this.listaClienteVendedorRubroIPT.findIndex((vendedor) => vendedor.vendedor_codigo === vendedor_codigo);
    this.listaClienteVendedorRubroIPT[vendedorSeleccionadoIndex].es_cobrador = true;

    this.setListaVendedoresFixed();
  }

  CambiaIPT(dia: string, rubroipt: any, index: any) {
    const { vendedor_codigo } = rubroipt;
    this.listaClienteVendedorRubroIPT.forEach((vendedor: cliente_vendedor_rubro_IPT) => {
      if (vendedor.vendedor_codigo === vendedor_codigo) {
        // vendedor.es_cobrador = false;
        vendedor[dia] = !vendedor[dia];
      }
    });

    this.setListaVendedoresFixed();
  }

  loadGrillaVendedores() {
    // listaClienteVendedorRubroIPT
    const self = this; // this is unused
    this.log('loadGrillaVendedores');

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalEmpresa,
      rutCliente: this.rutCliente,
      direccionCodigo: this.direccionCliente,
    };

    this.clientesService.obtenerSegunFiltroRubroeIPT(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;

      self.listaClienteVendedorRubroIPT = registros;
      self.setListaVendedoresFixed();
    });
  }

  setListaVendedoresFixed() {
    let listaVendedores = [];
    let lastVendedorCodigo = null;

    const vendedorRubrosVisiblesIndex = this.getVendedorRubrosVisiblesIndex();

    _.orderBy(this.listaClienteVendedorRubroIPT, ['vendedor_codigo'], ['asc']).forEach((vendedor) => {
      // nuevo registro
      if (lastVendedorCodigo !== vendedor.vendedor_codigo) {
        lastVendedorCodigo = vendedor.vendedor_codigo;
        listaVendedores.push(vendedor);
        listaVendedores[listaVendedores.length - 1].rubros = [];
        listaVendedores[listaVendedores.length - 1].rubrosVisibles = false;
        listaVendedores[listaVendedores.length - 1].front_id = `vendedor_${vendedor.vendedor_codigo}`;
      }

      // add rubro al actual (último)
      listaVendedores[listaVendedores.length - 1].rubros.push({ nombreRubro: vendedor.nombreRubro, rubro_codigo: vendedor.rubro_codigo });
    });

    // Set cobrador
    let hasDefaultCobrador = false;
    for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
      if (this.listaClienteVendedorRubroIPT[i].es_cobrador) {
        const cobradorIndex: number = listaVendedores.findIndex((vendedor) => vendedor.vendedor_codigo === this.listaClienteVendedorRubroIPT[i].vendedor_codigo);
        listaVendedores[cobradorIndex].es_cobrador = true;
        hasDefaultCobrador = true;
        break;
      }
    }
    this.listaClienteVendedorRubroIPTFixed = listaVendedores;

    if (vendedorRubrosVisiblesIndex >= 0 && this.listaClienteVendedorRubroIPTFixed && this.listaClienteVendedorRubroIPTFixed.length > vendedorRubrosVisiblesIndex) {
      this.listaClienteVendedorRubroIPTFixed[vendedorRubrosVisiblesIndex].rubrosVisibles = true;
    }

    if (!hasDefaultCobrador) this.setCobradorByDefault();
  }

  /***************Construccion de formularios reactivos****************/

  construyeFormAgregaDatosPersonales() {
    return new FormGroup({
      rutCliente: new FormControl(
        { value: '' },
        [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.validadores.ValidaFormatoRut]
        // this.validaExistenciaUsuario
      ),
      nombreCliente: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      tipoCliente: new FormControl('', [Validators.required]),
      estadoCliente: new FormControl({ value: false, disabled: true }),
      esClienteBloqueado: new FormControl(false),
    });
  }

  formAgregaDatosPersonalesChangesSubscriptions() {
    this.formAgregaDatosPersonales
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        const rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutCliente));
        this.queryValidaExistenciaUsuario(rut.toString(), ({ registros }) => {
          const matches = registros.filter((cliente) => cliente.rut === rut);
          if (matches.length > 0) {
            const rutClienteFormateado = this.validadores._enmascaraRut(rut.toString());
            this.toastService.error(`El rut ${rutClienteFormateado} ya existe`, 'Atención');
            this.editProveedorModal.hide();
          }
        });
      });
  }

  queryValidaExistenciaUsuario(rut: string, callback) {
    const inputParams = {
      nombre: '',
      rut,
      busquedaxEstado: 3,
      bloqueado: false,
      es_cliente: true,
      empresa_rut: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: 1,
    };

    this.clienteProveedorService.obtenerSegunFiltroSoloClientes(inputParams, (result) => {
      callback(result);
    });
  }

  construyeFormAgregaDatosDirecciones() {
    return new FormGroup({
      showCoordenadas: new FormControl({ value: false }),
      estadoDireccion: new FormControl({ value: true }),
      direccDesp: new FormControl({ value: false }),
      esCasaMatriz: new FormControl({ value: true }),
      region: new FormControl({ value: '' }),
      comuna: new FormControl({ value: '' }, [Validators.required]),
      nombre: new FormControl({ value: '' }, [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      direccion: new FormControl({ value: '' }, []),
      direccNueva: new FormControl({ value: '' }),
      usaDireccionDespacho: new FormControl({ value: true }),
      direccionDespacho: new FormControl({ value: '' }),
      contacto: new FormControl({ value: '' }, []),
      localidad: new FormControl({ value: '' }),
      fijo: new FormControl({ value: '' }),
      territorio: new FormControl({ value: '' }, [Validators.required]),
      movil: new FormControl({ value: '' }),
      ruta: new FormControl({ value: '' }, [Validators.required]),
      email: new FormControl({ value: '' }, [Validators.email]),
      latitud: new FormControl({ value: '' }, [Validators.required]),
      longitud: new FormControl({ value: '' }, [Validators.required]),
      referencias: new FormControl('', [Validators.maxLength(2000)]),
      facturarACasaMatriz: new FormControl({ value: this.RB_CASAMATRIZ_ }),
      direccionFormateada: new FormControl({ value: '' }),
      VendedorSel: new FormControl({ value: '' }),
      RubroSel: new FormControl({ value: '' }),
      secuencia: new FormControl({ value: 0 }),
    });
  }

  /********************************************************************/

  resetFormAgregar() {
    this.log('resetFormAgregar');
    this.formDatosPersonales.reset();
    this.formValidatorsService.reset(this.formDatosDirecciones);
    this.formDatosComerciales.reset();
    this.formDatosFinancieros.reset();
    this.formDatosPersonales.setAddDefaults();
    this.setDireccionesDefaults();
  }

  setDireccionesDefaults() {
    this.formDatosDirecciones.get('estadoDireccion').setValue(true);
  }

  showModalAgregar() {
    this.resetFormAgregar();
    this.staticTabs.setActiveTab(1);
    const self = this;
    const codigoOperacion = 7;

    this.listaClienteVendedorRubroIPT = [];
    this.listaClienteVendedorRubroIPTFixed = [];
    this.listaIPTVendedorClienteAgrega = [];
    this.listaVendedorRubroClienteAgrega = [];

    const inputParams = {
      rut_usu: self.rutUsuario,
      codgo_modulo: self.codigoModulo,
      cod_operacion: codigoOperacion,
    };

    this.clientesService.rolOperacionPermitida(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes[0].tipo === TipoMensaje.SUCCESS) {
        self.formDatosDirecciones.get('RubroSel').setValue(1); // Set rubro HELADOS, por defecto
        self.formDatosDirecciones.get('esCasaMatriz').setValue(true);
        self.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);
        self.manejadorDireccionDespacho(false);
        self.formDatosComerciales.reset();
        self.formDatosFinancieros.reset();
      } else {
        self.messageRendererService.showErrors(mensajes);
      }
    });
  }

  validarYAgregar() {
    this.validarExistenciaCliente((valido) => {
      if (valido) {
        this.validaExisteClienteProveedorParaAgregar();
      }
    });
  }

  validarExistenciaCliente(callback: (valido: boolean) => void) {
    const { rutCliente } = this.formDatosPersonales.getFormData();
    const rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutCliente));
    this.queryValidaExistenciaUsuario(rut.toString(), ({ registros }) => {
      const matches = registros.filter((cliente) => cliente.rut === rut);
      if (matches.length > 0) {
        const rutClienteFormateado = this.validadores._enmascaraRut(rut.toString());
        this.toastService.error(`El rut ${rutClienteFormateado} ya existe`, 'Atención');
        callback(false);
        return;
      }

      let valid = true;

      const formDatosFinancierosValid = this.formDatosFinancieros.validate();
      if (!formDatosFinancierosValid) {
        this.toastService.error('Complete datos financieros');
        valid = false;
      }

      const formDatosComercialesValid = this.formDatosComerciales.validate();
      if (!formDatosComercialesValid) {
        this.toastService.error('Complete datos comerciales');
        valid = false;
      }

      this.validateAllFormFields(this.formDatosDirecciones);
      if (!this.formDatosDirecciones.valid) {
        this.toastService.error('Complete datos direcciones');
        valid = false;
      }

      const formDatosPersonalesValid = this.formDatosPersonales.validate();
      if (!formDatosPersonalesValid) {
        this.toastService.error('Complete datos personales');
        valid = false;
      }

      callback(valid);
    });
  }

  validaExisteClienteProveedorParaAgregar() {
    const self = this; // this is unused
    self.insertarDatosPersonales();
  }

  insertarDatosPersonales() {
    const formDatosPersonales = this.formDatosPersonales.getFormData();
    const formDatosFinancieros = this.formDatosFinancieros.getFormData();
    const formDatosComerciales = this.formDatosComerciales.getFormData();

    this.itemCliente = {
      rut: Number(this.validadores._desenmascaraRutyQuitaDV(formDatosPersonales.rutCliente)),
      nombre: formDatosComerciales.nombreFantasia,
      activo: formDatosPersonales.estadoCliente,
      bloqueado: formDatosPersonales.esClienteBloqueado,
      tipo_cliente_codigo: formDatosPersonales.tipoCliente,
      razon_social: formDatosPersonales.nombreCliente,
      empresa_rut: this.rutEmpresa,
      afecto_reglas_comerciales: Boolean(formDatosFinancieros.clieneAfectoReglasComerciales),
      descuento_maximo: Number(formDatosFinancieros.descuentoMaximo),
      es_cliente: true,
      es_proveedor: true,
      fax: '',
      fecha_actualizacion: new Date(),
      fecha_registro: new Date(),
      lista_precio_codigo: Number(formDatosFinancieros.listaPrecios),
      mail_intercambio: formDatosComerciales.emailIntercambio,
      mail_pdf: formDatosComerciales.emailEnvioPdf,
      mail_contacto: formDatosComerciales.emailContacto,
      observaciones: '',
      rut_usuario_actualiza: this.rutUsuario,
      rut_usuario_creacion: this.rutUsuario,
      telefono_principal: '',
      telefono_secundario: '',
      tipo_cobro_codigo: Number(formDatosFinancieros.tipoCobro),
      codigoModulo: this.codigoModulo,
      limite_credito: Number(formDatosFinancieros.limiteCredito),
      giro: formDatosComerciales.giroComercial,
    };

    if (this.formDatosDirecciones.get('latitud').value === null || this.formDatosDirecciones.get('latitud').value === undefined || this.formDatosDirecciones.get('latitud').value === 'null') {
      this.formDatosDirecciones.get('latitud').setValue('');
      return;
    }
    if (this.formDatosDirecciones.get('longitud').value === null || this.formDatosDirecciones.get('longitud').value === undefined || this.formDatosDirecciones.get('longitud').value === 'null') {
      this.formDatosDirecciones.get('longitud').setValue('');
      return;
    }

    if (!this.formDatosDirecciones.get('latitud').valid || !this.formDatosDirecciones.get('longitud').valid) {
      return;
    }
    if (this.formDatosDirecciones.get('secuencia').value === '') {
      this.formDatosDirecciones.get('secuencia').setValue('0');
    }
    let tieneCobrador = false;
    this.listaIPTVendedorClienteAgrega = [];
    this.listaVendedorRubroClienteAgrega = [];
    if (this.listaClienteVendedorRubroIPT === null) {
      // alert(
      //   'Debe seleccionar algún vendedor y rubro para este cliente/dirección'
      // );
      this.toastService.warning('Debe seleccionar algún vendedor y rubro para este cliente/dirección');
      this.staticTabs.setActiveTab(2);
      // this.showModalAgregarDireccion();
      return false;
    }
    if (this.listaClienteVendedorRubroIPT.length === 0) {
      // alert(
      //   'Debe seleccionar algún vendedor y rubro para este cliente/dirección'
      // );
      this.toastService.warning('Debe seleccionar algún vendedor y rubro para este cliente/dirección');
      this.staticTabs.setActiveTab(2);
      // this.showModalAgregarDireccion();
      return false;
    }

    for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
      // this.listaClienteVendedorRubroIPT.forEach((element) => {
      if (
        !this.listaClienteVendedorRubroIPT[i].lunes &&
        !this.listaClienteVendedorRubroIPT[i].martes &&
        !this.listaClienteVendedorRubroIPT[i].miercoles &&
        !this.listaClienteVendedorRubroIPT[i].jueves &&
        !this.listaClienteVendedorRubroIPT[i].viernes &&
        !this.listaClienteVendedorRubroIPT[i].sabado &&
        !this.listaClienteVendedorRubroIPT[i].domingo
      ) {
        // alert(
        //   'El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado'
        // );
        this.toastService.warning('El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado');
        this.staticTabs.setActiveTab(2);
        //this.showModalAgregarDireccion();
        return false;
      }
      // if (element.es_cobrador) {
      //   tieneCobrador = true;
      // }
    }
    // );

    const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
    tieneCobrador = cobradoresMatches > 0;
    if (!tieneCobrador) {
      // alert('No se ha asignado ningún vendedor como cobrador.');
      this.toastService.warning('No se ha asignado ningún vendedor como cobrador.');
      // this.showModalAgregarDireccion(); // TODO: Why?????
      this.staticTabs.setActiveTab(2);
      return false;
    }

    this.listaClienteVendedorRubroIPT.forEach((element) => {
      let itemvrc: vendedor_rubro_cliente;
      let itemiptvc: ipt_vendedor_cliente;
      itemvrc = {
        rubro_codigo: element.rubro_codigo,
        cliente_proveedor_rut: this.itemCliente.rut,
        direccion_codigo: element.direccion_codigo,
        realiza_cobro_maquina: element.realiza_cobro_maquina,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo: element.vendedor_codigo,
      };
      this.listaVendedorRubroClienteAgrega.push(itemvrc);
      itemiptvc = {
        cliente_proveedor_rut: this.itemCliente.rut,
        direccion_codigo: element.direccion_codigo,
        lunes: element.lunes,
        martes: element.martes,
        miercoles: element.miercoles,
        jueves: element.jueves,
        viernes: element.viernes,
        sabado: element.sabado,
        domingo: element.domingo,
        empresa_rut: this.rutEmpresa,
        es_cobrador: element.es_cobrador,
        fecha_actualizacion: new Date(),
        fecha_registro: new Date(),
        vendedor_codigo: element.vendedor_codigo,
        listaUnidadNegocio: element.unidad_negocio_codigo,
      };
      this.listaIPTVendedorClienteAgrega.push(itemiptvc);
    });

    this.itemDireccion = {
      activo: this.formDatosDirecciones.get('estadoDireccion').value,
      es_direccion_despacho: this.formDatosDirecciones.get('direccDesp').value,
      cliente_proveedor_rut: this.itemCliente.rut,
      codigo: this.direccionCliente,
      codigo_direccion_despacho: this.formDatosDirecciones.get('direccionDespacho').value,
      comuna_codigo: this.formDatosDirecciones.get('comuna').value,
      direccion_completa: this.ShowLongLat == false ? this.formDatosDirecciones.get('direccion').value : this.formDatosDirecciones.get('direccNueva').value,
      email_contacto: this.formDatosDirecciones.get('email').value,
      empresa_rut: this.rutEmpresa,
      es_principal: this.formDatosDirecciones.get('esCasaMatriz').value,
      facturar_a_casa_matriz: this.formDatosDirecciones.get('facturarACasaMatriz').value,
      fecha_creacion: new Date(),
      fono_fijo: this.formDatosDirecciones.get('fijo').value,
      fono_movil: this.formDatosDirecciones.get('movil').value,
      latitud: String(this.formDatosDirecciones.get('latitud').value),
      longitud: String(this.formDatosDirecciones.get('longitud').value),
      secuencia: this.formDatosDirecciones.get('secuencia').value,
      localidad: this.formDatosDirecciones.get('localidad').value,
      nombre: this.formDatosDirecciones.get('nombre').value,
      nombre_contacto: this.formDatosDirecciones.get('contacto').value,
      referencias: this.formDatosDirecciones.get('referencias').value,
      ruta_codigo: this.formDatosDirecciones.get('ruta').value,
      territorio_codigo: this.formDatosDirecciones.get('territorio').value,
      usa_direccion_despacho: this.formDatosDirecciones.get('usaDireccionDespacho').value,
      condicion_pago_codigo: Number(formDatosFinancieros.condicionPago),
      rut_usuario: this.rutUsuario,
      codigoModulo: this.codigoModulo,
      moduloGrabacion: 2,
    };

    this.postClienteDatosPersonalesAgrega(this.itemCliente, this.itemDireccion, this.listaIPTVendedorClienteAgrega, this.listaVendedorRubroClienteAgrega);
  }

  obtenerDatosRegion() {
    const self = this; // this is unused

    this.clientesService.ObtenerAllRegion(({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      self.listaRegiones = registros;
      self.optionsRegion = [];
      let sel: any;
      self.listaRegiones.forEach((element) => {
        sel = { value: element.codigo, label: element.nombre };
        self.optionsRegion.push(sel);
      });
    });
  }

  loadComboRubros() {
    const self = this; // this is unused

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
    };

    this.clientesService.ObtenerRubrosCliente(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      self.listaRubros = registros;
      self.optionsRubro = [];
      let sel: any;
      self.listaRubros.forEach((element) => {
        sel = { value: element.codigo, label: element.descripcion };
        self.optionsRubro.push(sel);
      });
    });
  }

  obtenerDatosRuta() {
    const self = this; // this is unused

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalEmpresa,
    };

    this.clientesService.DatosRutaSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;

      self.listaRutasDireccion = registros;
      self.optionsRutaDireccion = [];
      let sel: any;
      self.listaRutasDireccion.forEach((element) => {
        sel = { value: element.codigo, label: element.descripcion };
        self.optionsRutaDireccion.push(sel);
      });
    });
  }

  obtenerDatosTerritorio() {
    const self = this; // this is unused

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalEmpresa,
    };

    this.clientesService.ObtenerTerritorioSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      self.listaTerritoriosDireccion = registros;
      self.optionsTerritorioDireccion = [];
      let sel: any;
      self.listaTerritoriosDireccion.forEach((element) => {
        sel = { value: element.codigo, label: element.nombre };
        self.optionsTerritorioDireccion.push(sel);
      });
    });
  }

  obtenerDatosVendedores() {
    const self = this; // this is unused
    // const regionSeleccionada = this.formDatosDirecciones.get('region')
    //   .value;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalCodigo: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaVendedor = respuesta.data.vendedor.obtenerSegunFiltro.respuesta.registros;
        self.optionsVendedor = [];
        let sel: any;
        self.listaVendedor.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsVendedor.push(sel);
        });
      }
    );
  }

  obtenerDatosComunas() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query {
            comuna {
              obtenerSegunFiltro(filtro: { exacto: { codigo: -1, provincia_codigo: -1, nombre: "", codigo_region: -1 } }) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    provincia_codigo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaComunasFiltro = respuesta.data.comuna.obtenerSegunFiltro.respuesta.registros;
        self.optionsFiltroComuna = [];
        self.optionsDatosDireccionAgregarComuna = [];
        let sel: any;
        self.listaComunasFiltro.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsFiltroComuna.push(sel);
          self.optionsDatosDireccionAgregarComuna.push(sel);
        });
      }
    );
  }

  obtenerDatosTipoCliente() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query {
            tipo_cliente {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaTipoClientes = respuesta.data.tipo_cliente.obtenerTodos.respuesta.registros;
        self.optionsTipoCliente = [];
        let sel: any;
        self.listaTipoClientes.forEach((element) => {
          sel = { value: element.codigo, label: element.descripcion };
          self.optionsTipoCliente.push(sel);
        });
      }
    );
  }

  obtenerDatosModalFinancieros() {
    const self = this;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $sucursalEmpresa: Decimal) {
            condicion_pago {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }

            lista_precio {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalEmpresa, codigo: -1 } }) {
                respuesta {
                  registros {
                    codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalCodigo: this.sucursalEmpresa,
          sucursalEmpresa: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        // const { registros: listaTipoCobro } = respuesta.data.tipo_cobro.obtenerTodos.respuesta;
        // self.optionsTipoCobro = listaTipoCobro.map(p => ({ value: p.codigo, label: p.descripcion }))
        // self.log('self.optionsTipoCobro', self.optionsTipoCobro)

        const { registros: listaCondicionDePago } = respuesta.data.condicion_pago.obtenerSegunFiltro.respuesta; //.registros.filter(p => p.estado);
        self.optionsCondicionPago = listaCondicionDePago.map((p) => ({ value: p.codigo, label: p.descripcion }));

        const { registros: listaPrecios } = respuesta.data.lista_precio.obtenerSegunFiltro.respuesta; //.registros.filter(p => p.estado);
        self.optionsListaPrecios = listaPrecios.map((p) => ({ value: p.codigo, label: p.codigo }));
      }
    );
  }

  limpiarfiltros() {}

  loadComboDirecciones() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal) {
            direccion {
              obtenerSegunFiltro(filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, direccion_completa: "", nombre: "", activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.rutCliente,
        },
      },
      function (respuesta) {
        self.listaDireccionesCombo = respuesta.data.direccion.obtenerSegunFiltro.respuesta.registros;
        self.optionsDireccion = [];
        let sel: any;
        if (self.listaDireccionesCombo.length > 0) {
          self.listaDireccionesCombo.forEach((element) => {
            sel = { value: element.codigo, label: element.nombre };
            self.optionsDireccion.push(sel);
          });
        } else {
          sel = { value: -1, label: '' };
          self.optionsDireccion.push(sel);
        }
      }
    );
  }

  filtraGrillaDirecciones() {
    const self = this; // this is unused

    this.filtroDireccionNombre = this.filtroDireccionNombre === undefined ? '' : this.filtroDireccionNombre;
    this.filtroDireccionDireccion = this.filtroDireccionDireccion === undefined ? '' : this.filtroDireccionDireccion;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $nombreDireccion: String, $direccionCompleta: String, $paginaActual: Int) {
            direccion {
              obtenerSegunFiltro(
                filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, direccion_completa: $direccionCompleta, nombre: $nombreDireccion } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: 10
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    es_principal
                    territorio_codigo
                    ruta_codigo
                    empresa_rut
                    fecha_creacion
                    nombre
                    nombre_contacto
                    codigo_direccion_despacho
                    usa_direccion_despacho
                    localidad
                    fono_fijo
                    fono_movil
                    email_contacto
                    latitud
                    longitud
                    referencias
                    facturar_a_casa_matriz
                    activo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.rutCliente,
          nombreDireccion: this.filtroDireccionNombre,
          direccionCompleta: this.filtroPrincipalDireccionCliente,
          paginaActual: this.paginaActualDirecciones,
        },
      },
      function (respuesta) {
        self.listaDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.registros;
        self.totalRegistrosDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.totalRegistros;
        self.totalPaginasDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.totalPaginas;
        if (self.totalPaginasDirecciones === 0) {
          self.totalPaginasDirecciones = 1;
        }
      }
    );
  }

  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }

  postClienteDatosPersonalesAgrega(
    clienteIngresado: cliente_proveedor,
    direccionIngresada: direccion,
    listaIPTVendedorCliente: ipt_vendedor_cliente[],
    listaVendedorRubroCliente: vendedor_rubro_cliente[]
  ) {
    const self = this;
    const bodyx = clienteIngresado;

    listaVendedorRubroCliente.forEach(function (item) {
      item.direccion_codigo = self.direccionCliente;
    });
    listaIPTVendedorCliente.forEach(function (item) {
      item.direccion_codigo = self.direccionCliente;
    });

    this.client.mutate(
      {
        mutation: gql`
          mutation (
            $entidadCliente: cliente_proveedorInputType
            $entidadDireccion: direccionInputType
            $entidadIPTVendedor: ipt_vendedor_clienteListaInputType
            $entidadVendedorRubro: vendedor_rubro_clienteListaInputType
          ) {
            cliente_proveedor {
              editarClienteCompleto(entidadCliente: $entidadCliente, entidadDireccion: $entidadDireccion, entidadIPTVendedor: $entidadIPTVendedor, entidadVendedorRubro: $entidadVendedorRubro) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          entidadCliente: bodyx,
          entidadDireccion: direccionIngresada,
          entidadIPTVendedor: { obj: listaIPTVendedorCliente },
          entidadVendedorRubro: { obj: listaVendedorRubroCliente },
        },
      },
      function (respuesta) {
        if (respuesta.data.cliente_proveedor.editarClienteCompleto.respuesta != null) {
          // alert("Registro grabado");
          self.toastService.success('Registro grabado');
          self.editProveedorModal.hide();
          setTimeout(() => self.buscar(), 1000);
        } else {
          self.messageRendererService.showErrors(respuesta.data.cliente_proveedor.editarClienteCompleto.mensajes);
        }
      }
    );
  }

  //TODO: FORM PARA EDITAR PROVEEDOR
  manejadorDireccionDespacho(edita: boolean) {
    {
      if (Boolean(this.formDatosDirecciones.get('usaDireccionDespacho').value)) {
        this.formDatosDirecciones.get('direccionDespacho').reset();
        this.formDatosDirecciones.get('direccionDespacho').disable();
        if (this.direccionCliente !== -1) {
          this.formDatosDirecciones.get('direccionDespacho').setValue(this.direccionCliente);
        }
        this.formDatosDirecciones.get('direccionDespacho').setValidators([]);
      } else {
        if (this.listaDirecciones === undefined) {
          this.listaDireccionesCombo = [];
        }
        if (this.listaDireccionesCombo.length <= 0) {
          // alert('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
          this.toastService.warning('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
          this.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);
        } else {
          this.formDatosDirecciones.get('direccionDespacho').enable();

          this.formDatosDirecciones.get('direccionDespacho').reset();
          this.formDatosDirecciones.get('direccionDespacho').setValidators([Validators.required]);
        }
      }
    }
  }

  /********* MODAL DATOS COMERCIALES *********/

  /********* MODAL DATOS COMERCIALES *********/

  /********* MODAL DATOS FINANCIEROS *********/

  /********* MODAL DATOS FINANCIEROS *********/

  /********* MODAL RESUMEN *********/
  detalleClientePrint() {
    window.print();
    // this.resumenModal.hide();
  }
  /********* MODAL RESUMEN *********/

  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  setNombreDireccion(nombre: string) {
    this.formDatosDirecciones.get('nombre').setValue(nombre);
    this.formDatosDirecciones.get('nombre').setValue(nombre);
  }

  //TODO: DATA PARA EDITAR PROVEEDOR
  onNombreDatosPersonalesChange(nombre: string) {
    this.setNombreDireccion(nombre);
    this.formDatosComerciales.setNombreFantasia(nombre);
  }

  verRubros(rubroipt, i) {
    const vendedorRubrosVisiblesIndex = this.getVendedorRubrosVisiblesIndex();
    const vendedorSeleccionadoIndex = this.listaClienteVendedorRubroIPTFixed.findIndex((vendedor: cliente_vendedor_rubro_IPTFixed) => vendedor.vendedor_codigo === rubroipt.vendedor_codigo);
    this.hideAllRubrosPanel();

    if (vendedorRubrosVisiblesIndex !== vendedorSeleccionadoIndex) this.listaClienteVendedorRubroIPTFixed[vendedorSeleccionadoIndex].rubrosVisibles = true;
  }

  getVendedorRubrosVisiblesIndex() {
    return this.listaClienteVendedorRubroIPTFixed ? this.listaClienteVendedorRubroIPTFixed.findIndex((vendedor: cliente_vendedor_rubro_IPTFixed) => vendedor.rubrosVisibles) : -1;
  }

  hideAllRubrosPanel() {
    this.listaClienteVendedorRubroIPTFixed.forEach((vendedor: cliente_vendedor_rubro_IPTFixed) => {
      vendedor.rubrosVisibles = false;
    });
  }

  buscar() {
    this.onSuccess.emit();
  }

  NextTab(enable) {
    let valid = true;

    this.staticTabs.getActive();
    switch (enable) {
      case 1:
        const formDatosPersonalesValid = this.formDatosPersonales.validate();
        if (!formDatosPersonalesValid) {
          this.toastService.error('Complete datos personales');
          this.staticTabs.setActiveTab(1);
          valid = false;
        } else {
          this.staticTabs.setActiveTab(2);
          this.EnableNext = 2;
        }
        break;

      case 2:
        this.validateAllFormFields(this.formDatosDirecciones);
        if (!this.formDatosDirecciones.valid) {
          this.toastService.error('Complete datos direcciones');
          this.staticTabs.setActiveTab(2);
          valid = false;
        } else {
          this.staticTabs.setActiveTab(3);
          this.EnableNext = 3;
        }

        break;
      case 3:
        const formDatosComercialesValid = this.formDatosComerciales.validate();
        if (!formDatosComercialesValid) {
          this.toastService.error('Complete datos comerciales');
          this.staticTabs.setActiveTab(3);
          valid = false;
        } else {
          this.staticTabs.setActiveTab(4);
          this.EnableNext = 4;
        }
        break;
      default:
        break;
    }
  }
}
